import type { ConsoleStatsResponse } from "@redipos/contracts";
import { http } from "../../shared/http.js";

export const analyticsApi = {
  stats: () => http.get<ConsoleStatsResponse>("/admin/analytics/stats"),
};
